import {detect} from 'detect-browser';

const browser = detect();

export const isFirefox = browser?.name === 'firefox';
export const isSafari = browser?.name === 'safari';
